var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-mobile-menu",on:{"click":function($event){$event.preventDefault();return _vm.$root.$emit('showMobileMenu')}}},[_c('i',{staticClass:"fa fa-bars"})])}
var staticRenderFns = []

export { render, staticRenderFns }